import Cookies from 'js-cookie';
import { clearErrors, setAlert, setSuccess } from './alertActions';

// API
import { login, logout, getAccount, registerAccount } from '../../api';

// Constants
export const IS_LOADING = 'IS_LOADING';
export const IS_NOT_LOADING = 'IS_NOT_LOADING';
export const FULLY_AUTHENTICATED = 'FULLY_AUTHENTICATED';
export const NOT_AUTHENTICATED = 'NOT_AUTHENTICATED';

const FULL_COOKIE_NAME = process.env.REACT_APP_COOKIE_NAME;

// Actions
export const startLoading = () => ({
  type: IS_LOADING
});

export const stopLoading = () => ({
  type: IS_NOT_LOADING
});

export const fullyAuthenticated = () => ({
  type: FULLY_AUTHENTICATED
});

export const notAuthenticated = () => ({
  type: NOT_AUTHENTICATED
});

/* ----- AUTHENTICATE ----- */
export const fullyAuthenticateUser = (dispatch, email = null, password = null) => {
  dispatch(startLoading());

  login({ email, password }).then(() => {
    dispatch(clearErrors());
    dispatch(fullyAuthenticated());
  }).catch(error => {
    setAlert(dispatch, error);
    dispatch(notAuthenticated());
  });
};

export const registerUser = (dispatch, userObj) => {
  dispatch(startLoading());

  registerAccount(userObj).then(() => {
    dispatch(clearErrors());
    dispatch(setSuccess('Successfully registered. Please check your email to verify your account.'));
  }).catch(error => {
    setAlert(dispatch, error);
    dispatch(notAuthenticated());
  });
}

export const checkAuthentication = (dispatch, isFullyAuthenticated) => {
  dispatch(startLoading());

  // If we falsely have the user logged in, log them out and clear all cookies.
  if ((Cookies.get(FULL_COOKIE_NAME) == null && isFullyAuthenticated)) {
    logoutUser(dispatch);
  }

  else if (Cookies.get(FULL_COOKIE_NAME) != null && !isFullyAuthenticated) {
    getAccount().then(() => {
      dispatch(fullyAuthenticated());
    }).catch(error => {
      console.log(error);
      dispatch(notAuthenticated());
    });
  }

  else dispatch(stopLoading());
};

export const logoutUser = (dispatch) => {
  // Revoke tokens and unauthenticate in redux state
  if (Cookies.get(FULL_COOKIE_NAME) != null) {
    logout().then(() => {
      setSuccess('Successfully logged out.');
      clearCookies(dispatch);
    }).catch(() => {
      clearCookies(dispatch);
    });
  }
  else clearCookies(dispatch);
};

export const clearCookies = (dispatch) => {
  Cookies.remove(FULL_COOKIE_NAME, { path: '/', domain: process.env.REACT_APP_COOKIE_DOMAIN });
  dispatch(notAuthenticated());
};